<script lang="ts">
import { defineComponent, PropType, ref } from 'vue';
import { AttributeWebCollection, AttributeWebItem, ProductVariation, ProductWebItem } from 'src/core/types/Products';
import { useQuasar } from 'quasar';

export default defineComponent({
  name: 'ProductListItem',

  props: {
    product: {
      required: true,
      type: Object as PropType<ProductWebItem[]>,
    },
  },

  setup() {
    const $q = useQuasar();

    const mobile = ref($q.platform.is.mobile);

    return {
      mobile,
    };
  },

  methods: {
    getProductFeatures(productAttrs: AttributeWebCollection, attrs: ProductVariation['attrs']) {
      const attrsArr: AttributeWebItem[] = [];

      Object.values(attrs).forEach((attr) => {
        const find = productAttrs.find((o) => o.code === Number(attr));
        if (find) {
          attrsArr.push(find);
        }
      });

      return attrsArr;
    },
  },
});
</script>

<template>
  <q-item>
    <q-item-section avatar>
      <q-img :src="product.variations[0].images[0]" :ratio="16 / 9" width="150px" height="92px" />
    </q-item-section>
    <q-item-section v-if="!mobile">
      <q-item-label>
        <span class="text-weight-bold">{{ product.name }}</span>
      </q-item-label>
      <q-item-label v-if="product.type !== 0" caption>
        <strong>Özellikler:</strong>
        {{ product.attributeValues.map((o) => o.name).join(', ') }}
      </q-item-label>
      <q-item-label v-else caption>
        <strong>Kategori:</strong>
        {{ product.category.name }}
      </q-item-label>
      <!--      <q-item-label>-->
      <!--        <span>-</span>-->
      <!--      </q-item-label>-->
      <q-item-label class="text-weight-bold">{{ $numberToCurrency(product.variations[0].price) }} ₺</q-item-label>
    </q-item-section>
    <slot name="append" />
  </q-item>
  <q-item>
    <q-item-section v-if="mobile">
      <q-item-label>
        <span class="text-weight-bold">{{ product.name }}</span>
      </q-item-label>
      <q-item-label v-if="product.type !== 0" caption>
        <strong>Özellikler:</strong>
        {{ product.attributeValues.map((o) => o.name).join(', ') }}
      </q-item-label>
      <q-item-label v-else caption>
        <strong>Kategori:</strong>
        {{ product.category.name }}
      </q-item-label>
      <!--      <q-item-label>-->
      <!--        <span>-</span>-->
      <!--      </q-item-label>-->
      <q-item-label class="text-weight-bold">{{ $numberToCurrency(product.variations[0].price) }} ₺</q-item-label>
    </q-item-section>
  </q-item>
</template>

<style scoped lang="sass"></style>
